import {
    GET_SUBPOENA_REQUESTS,
    GET_SUBPOENA_REQUEST_DETAILS,
    GET_SUBPOENA_MODULES,
    SELECTED_SUBPOENA_REGION_FILTER,
  } from "../actions";
  
  export const subpoenaRequestsReducer = (state = false, action) => {
    switch (action.type) {
      case GET_SUBPOENA_REQUESTS:
        return action.payload;
      default:
        return state;
    }
  };
  
  export const subpoenaRequestDetailsReducer = (state = false, action) => {
    switch (action.type) {
      case GET_SUBPOENA_REQUEST_DETAILS:
        return action.payload;
      default:
        return state;
    }
  };
  
  export const subpoenaModulesReducer = (state = false, action) => {
    switch (action.type) {
      case GET_SUBPOENA_MODULES:
        return action.payload;
      default:
        return state;
    }
  };
  
  export const subpoenaRegionFilterReducer = (state = false, action) => {
    switch (action.type) {
      case SELECTED_SUBPOENA_REGION_FILTER:
        return action.payload;
      default:
        return state;
    }
  };
  
  